import React from 'react';
import UnifiedCoverageContainer from './components/UnifiedCoverageContainer';
import Sidebar from '../../components/Sidebar/Sidebar';
import { IconCreditCardPay, IconInputSearch } from '@tabler/icons-react';

const sidebarItems = [
  {
    icon: <IconInputSearch size={24} />,
    label: 'Drug Search',
    path: '/landing/drug-search',
  },
  {
    icon: <IconCreditCardPay size={24} />,
    label: 'Coverage Verification',
    path: '/landing/coverage-verification-new',
  },
];

/**
 * CoverageVerification Component
 * Main page for the new unified coverage verification module
 * Now using UnifiedCoverageContainer for consistent layout
 */
const CoverageVerification = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-12 col-md-3 col-xl-2 side-menu">
          <Sidebar items={sidebarItems} />
        </div>

        {/* Main Content */}
        <div className="col-12 col-md-9 col-xl-10 bg-white min-h-screen">
          <UnifiedCoverageContainer />
        </div>
      </div>
    </div>
  );
};

export default CoverageVerification;
